<template>
    <div>
        <AsaComponent/>
    </div>
</template>

<script>

import AsaComponent from "../components/DataComponents/AsaComponent.vue";

export default {
  name: "asa-data-view",
  components: { AsaComponent },
  title: 'Asa',
}
</script>
